import { WebStorageStateStore } from "oidc-client-ts";
import type { AuthProviderProps } from "react-oidc-context";

import { cleanOidcUrlAndRedirectHome } from "utils/oidcUrl";

const authority = process.env.REACT_APP_OIDC_AUTHORITY!;

const getOidcClientId = (): string => {
  if (process.env.NODE_ENV === "development") {
    return "buportal-d.supergasbras.app";
  }

  return window.location.origin.replace(/^https?:\/\//, "");
};

console.log("authority", authority);

export const oidcConfig: AuthProviderProps = {
  authority,
  client_id: getOidcClientId(),
  redirect_uri: window.location.origin,
  post_logout_redirect_uri: window.location.origin,
  response_type: "code",
  scope: "openid profile email",
  automaticSilentRenew: true,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  onSigninCallback: () => {
    cleanOidcUrlAndRedirectHome();
  },
};
